export default "__VITE_ASSET__1dFZT5Rx__"